import _asyncToGenerator from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.regexp.replace.js";
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import '@quasar/extras/fontawesome-v5/fontawesome-v5.css';
import '@quasar/extras/line-awesome/line-awesome.css';
import '@quasar/extras/material-icons/material-icons.css';

// We load Quasar stylesheet file
import 'quasar/dist/quasar.styl';

// We add Quasar addons, if they were requested
import 'quasar/src/css/flex-addon.styl';
import 'src/css/app.styl';
import 'src/css/app.scss';
import Vue from 'vue';
import createApp from "./app.js";
import qboot_Bootaxios from 'boot/axios';
import qboot_Bootfilters from 'boot/filters';
import qboot_Booti18n from 'boot/i18n';
import qboot_Bootutilities from 'boot/utilities';
import qboot_Bootvuesocialsharing from 'boot/vue-social-sharing';
import qboot_Bootvuexormaxios from 'boot/vuex-orm-axios';
import qboot_Bootglobalmixins from 'boot/global-mixins';
import qboot_Bootleaflet from 'boot/leaflet';
import qboot_Bootprintjs from 'boot/print-js';
import { addPreFetchHooks } from "./client-prefetch.js";
function start() {
  return _start.apply(this, arguments);
}
function _start() {
  _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$createApp, app, store, router, routeUnchanged, redirect, urlPath, bootFiles, i, appInstance;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return createApp();
        case 2:
          _yield$createApp = _context.sent;
          app = _yield$createApp.app;
          store = _yield$createApp.store;
          router = _yield$createApp.router;
          // prime the store with server-initialized state.
          // the state is determined during SSR and inlined in the page markup.
          if (window.__INITIAL_STATE__) {
            store.replaceState(window.__INITIAL_STATE__);
          }
          routeUnchanged = true;
          redirect = function redirect(url) {
            routeUnchanged = false;
            window.location.href = url;
          };
          urlPath = window.location.href.replace(window.location.origin, '');
          bootFiles = [qboot_Bootaxios, qboot_Bootfilters, qboot_Booti18n, qboot_Bootutilities, qboot_Bootvuesocialsharing, qboot_Bootvuexormaxios, qboot_Bootglobalmixins, qboot_Bootleaflet, qboot_Bootprintjs];
          i = 0;
        case 12:
          if (!(routeUnchanged === true && i < bootFiles.length)) {
            _context.next = 30;
            break;
          }
          if (!(typeof bootFiles[i] !== 'function')) {
            _context.next = 15;
            break;
          }
          return _context.abrupt("continue", 27);
        case 15:
          _context.prev = 15;
          _context.next = 18;
          return bootFiles[i]({
            app: app,
            router: router,
            store: store,
            Vue: Vue,
            ssrContext: null,
            redirect: redirect,
            urlPath: urlPath
          });
        case 18:
          _context.next = 27;
          break;
        case 20:
          _context.prev = 20;
          _context.t0 = _context["catch"](15);
          if (!(_context.t0 && _context.t0.url)) {
            _context.next = 25;
            break;
          }
          window.location.href = _context.t0.url;
          return _context.abrupt("return");
        case 25:
          console.error('[Quasar] boot error:', _context.t0);
          return _context.abrupt("return");
        case 27:
          i++;
          _context.next = 12;
          break;
        case 30:
          if (!(routeUnchanged === false)) {
            _context.next = 32;
            break;
          }
          return _context.abrupt("return");
        case 32:
          appInstance = new Vue(app); // wait until router has resolved all async before hooks
          // and async components...
          router.onReady(function () {
            addPreFetchHooks(router, store);
            appInstance.$mount('#q-app');
          });
        case 34:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[15, 20]]);
  }));
  return _start.apply(this, arguments);
}
start();